import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .filter('TrustedHtml', TrustedHtml);

    function TrustedHtml($sce) {
        return function (content) {
            return $sce.trustAsHtml(content);
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/filters/trusted_html.filter.ts